import { Circle, Page } from '@/components';
import { useSearchParams } from '@/hooks';
import { collateralColorPalette } from '@/theme/utils/collateralColorPalette';
import { Flex, Heading } from '@blockanalitica/ui';
import { useTheme } from 'styled-components';
import HistoricTabs from './HistoricTabs';
import IlksTable from './IlksTable';
import KpiOverview from './KpiOverview';
import { LinkButton, ExternalLinkIcon } from '@/components';

export default function GrovePage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const theme = useTheme();
  return (
    <Page
      title={
        <Flex gap="3xs" alignItems="center">
          <Circle
            size="3"
            color={collateralColorPalette(
              'grove',
              theme.colors.collateralColors
            )}
          />
          <Heading size="1">Grove</Heading>
        </Flex>
      }
      actions={
        <LinkButton to="https://data.grove.finance/" target="_blank">
          <Flex gap="3xs" alignItems="center" style={{ whiteSpace: 'nowrap' }}>
            Grove Dashboard
            <ExternalLinkIcon size="1" />
          </Flex>
        </LinkButton>
      }>
      <KpiOverview daysAgo={daysAgo} />
      <HistoricTabs />
      <IlksTable daysAgo={daysAgo} />
    </Page>
  );
}
